import Table from '@/common/components/Table';
import React, { useMemo } from 'react';
import { getRows } from '../../helpers/getRows';
import { REFUND_TABLE_HEADERS } from '../../constants/refundTableHeaders';


const RefundTable = ({ hook }) => {

	const rows = useMemo(() => {
		if (!hook.refunds?.length) {
			return [];
		}
		return getRows(hook.refunds, hook.setSelectedRefund, hook.handleDownloadPdf, hook.loadingFiles);
	}, [hook.refunds, hook.loadingFiles]);

	return (
		<Table className='styled-table' headers={REFUND_TABLE_HEADERS} raws={rows} />
	);
};

export default RefundTable;
